import styles from './HeaderFixed.styles';

interface HeaderFixedProps {
  children: React.ReactNode;
}

export const HeaderFixed: React.FC<HeaderFixedProps> = ({ children }) => (
  <header className={styles.container} id="headerFixed" data-testid="headerFixed">
    {children}
  </header>
);
